<template>
    <van-tabbar route v-model="active" :safe-area-inset-bottom="true" :placeholder="true">
        <van-tabbar-item v-for = "(item,i) in menus" :icon="item.icon" replace :to="item.path" :key="i">
            <span>{{item.title}}</span>
            <template #icon="props" v-if="!item.icon">
                <img :src="props.active ? item.active : item.inactive" />
            </template>
        </van-tabbar-item>
    </van-tabbar>
</template>

<script>
export default {
  name: 'LayoutFooter',
  props: {
    menus: Array
  },
  data () {
    return {
      active: 0
    }
  }
}
</script>
